import { MemberEmail } from '../../types/members.types';

import {
  TeamMemberFormAccessLevel,
  TeamMemberFormAccessPermissions,
  TeamMemberPermissions,
} from './team.constants';
import { MultiSelectTag } from '@wix/design-system';

export enum TeamMemberStatus {
  Accepted = 'accepted',
  Pending = 'pending',
}

export interface TeamMemberSecurityGroup {
  permission: TeamMemberPermissions;
  projectId?: string;
}

export interface TeamMember {
  id: string;
  avatarUrl: string;
  name: string;
  primaryEmail: MemberEmail;
  securityGroups: TeamMemberSecurityGroup[];
  permissions?: TeamMemberFormAccessPermissions;
  status: TeamMemberStatus;
}

export interface TeamMemberAccess {
  level: TeamMemberFormAccessLevel | undefined;
  permissions: TeamMemberFormAccessPermissions;
  projectsIds: string[];
}

export interface TeamMemberFormValues {
  emails: MultiSelectTag[];
  securityGroups: TeamMemberAccess[];
}

export interface TeamMembersData {
  emails: string[];
  securityGroups: string[];
}

export interface TeamMemberEditFormValues {
  securityGroups: TeamMemberAccess[];
}
